import { type UiHStackProps } from '@/lib/ui';
import { useDisclosure } from '@chakra-ui/react';
import { type FC } from 'react';
import ConfirmationPageForm from './ConfirmationPageForm';
import PageRow from './PageRow';

export interface ManageLabelsProps extends UiHStackProps {
}

const ConfirmationPage: FC<ManageLabelsProps> = ({ ...props }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <PageRow
        title={'Confirmation page'}
        description={'Manage the title and message that display to attendees on the registration confirmation page.'}
        onEdit={onToggle}
        {...props}
      />
      <ConfirmationPageForm
        onSaveSuccess={() => {}}
        isVisible={isOpen}
        onClose={onToggle}
      />
    </>
  );
};

export default ConfirmationPage;
